module.exports = __webpack_public_path__ + "static/img/group_detail_icon.7b633280.svg";